import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';
import { ScheduleTrigger } from '.';
import { getRRuleFromString } from '@kizen/rrule';

const forApi = (orgDetails: ScheduleTrigger) => {
  const { rrule, isAdvanced } = orgDetails;
  return {
    rrule,
    isAdvanced: !!isAdvanced,
  };
};

const forFlow = (trigger: ScheduleTrigger) => {
  const { rrule, isAdvanced = false } = trigger;
  const { occurrences } = getRRuleFromString(rrule);
  const type = AUTOMATION_STEPS.schedule.type;
  return {
    type,
    rrule,
    isAdvanced,
    occurrences,
  };
};

export const scheduleDTO = {
  forApi,
  forFlow,
};
